import React, {useState, useContext} from "react";
import styles from '.././ProfileEdit.module.sass';
import { ConquerContext } from "../../../contexts/ConquerContext";
import { UserContext } from "../../../contexts/UserContext";
import TextInput from '../../../components/TextInput';
import cn from 'classnames';
import PasswordRecoverForm from "../../../components/AuthForms/PasswordRecoverForm";
import { ModalContext } from "../../../contexts/Modal/ModalContext";

const PasswordSection = () => {

    const {show, hide} = useContext( ModalContext );
    const userContext = useContext( UserContext );

    function tryToChangePassword(){
        console.log( userContext.userData );
        show( { content: <PasswordRecoverForm customEmail={userContext.userData.email} onFinishCallback={hide}/>, title: 'Change Password' } );
    }

    return <>
        <button className={cn('button', styles.button)} onClick={tryToChangePassword}>
            Change Password
        </button>
    </>;

};

export default PasswordSection;